"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
exports.getBlockTooltipLabel = (block) => {
    const orderParenthetical = typeof block.order === 'number' ? ` (block #${block.order + 1})` : '';
    const labelSuffix = `${block.name ? ` - ${block.name}` : ''}${orderParenthetical}`;
    if (block.type === 'field') {
        return `${lodash_1.startCase(block.fieldType)} field${labelSuffix}`;
    }
    return `${lodash_1.startCase(block.type)} block${labelSuffix}`;
};
//# sourceMappingURL=getBlockTooltipLabel.js.map